/*
This component is matched with the nunjucks locale-switcher-footer component.
Every change made in this component should be checked and updated (if necessary) in its matching component and viceversa.
*/

import { useState, useEffect } from "preact/hooks";
import { useSignalEffect } from "@preact/signals";
import { html } from "htm/preact";
import { openId } from "./state.js";
import { setLocaleCookie } from "../utils/utils.js";

export default function LocaleSwitcherFooter({
  lang,
  locales,
  pages
}) {
  const [open, setOpen] = useState(false);

  useSignalEffect(() => {
    if (openId.value !== "locale-switcher-footer") {
      setOpen(false)
    }
  })

  const langBtnFunc = function () {
    if (open) {
      openId.value = "";
      setOpen(false);
    } else {
      openId.value = "locale-switcher-footer";
      setOpen(true);
    }
  };

  function getLanguage() {
    for (const locale of locales) {
      if (locale.code == lang) {
        return `${locale.label}`
      }
    }
  }

  useEffect(() => {
    const nav = document.querySelector("[data-locale-switcher-footer]");
    
    if (nav) {
      if (open) {
        nav.setAttribute("data-active", "");
      } else {
        nav.removeAttribute("data-active");
      }
    }
  }, [open])

  const handleLocaleChange = (e, localeCode, url) => {
    e.preventDefault();
    setLocaleCookie(localeCode);
    window.location.href = url;
  };

  return html`
    <div
    role="button"
    class="locale-switcher-button relative z-20 px-3 py-2 inline-flex items-center gap-x-1 leading-6 cursor-pointer rounded-lg border border-zinc-700 bg-zinc-900 text-zinc-100 group-data-active:rounded-b-lg group-data-active:rounded-t-none group-data-active:bg-olive-500/10"
    id="locale-button-footer"
    onclick=${langBtnFunc}
    title="{{ i18n.ui.change_locale[lang] }}">
    <span class="sr-only">${lang}</span>
    <svg width="16" height="16" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg" role="img" fill="none" class="size-5 stroke-2 stroke-current lg:size-4" aria-hidden="true">
      <circle cx="24" cy="24" r="23" stroke-linejoin="round"></circle>
      <path d="M23 1C23 1 15 10.4901 15 24C15 37.5099 23 47 23 47" stroke-linejoin="round"></path>
      <path d="M25 1C25 1 33 10.4901 33 24C33 37.5099 25 47 25 47" stroke-linejoin="round"></path>
      <path d="M1 24H47"></path>
    </svg>
    <div class="inline-flex items-center gap-x-1">
      <span class="ml-1">${getLanguage()}</span>
      <svg id="locale-button-caret-footer" class="h-4 w-4 flex-none transition-transform group-data-active:rotate-180" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="1">
        <path d="M5.5 7.5l4.493 5 4.507-5" fill="none" stroke="currentColor"/>
      </svg>
    </div>
  </div>

  <div
    class="locale-switcher-menu invisible opacity-0 group-data-active:visible group-data-active:opacity-100 left-0 bottom-full -translate-y-[-1px] absolute z-10 w-full origin-bottom-left bg-zinc-900 rounded-t-lg rounded-b-none border border-b-0 border-zinc-700 focus:outline-none"
    role="menu"
    aria-orientation="vertical"
    aria-labelledby="locale-button-footer"
    tabindex="-1">
    <div class="flex flex-col gap-1 p-2 text-sm leading-6 text-zinc-300" role="none">
        
      ${Object.values(pages).map(page => {
  const locale = locales.find(l => l.code === page.lang);
  return page ? html`
    <div key=${page.lang}>
      <a 
        href=${page.url}
        onclick=${(e) => handleLocaleChange(e, page.lang, page.url)}
        title=${locale?.label}
        lang=${page.lang}
        class="transition-colors flex px-2 py-1.5 select-none text-sm rounded-md hover:bg-olive-500/10 text-zinc-300"
      >
        ${locale?.label}
      </a>
    </div>` : null;
})}  
        
    </div>

  </div>
  `;

}
